var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.1604 17.1601V30.84C42.1604 33.08 40.9604 35.1601 39.0204 36.3001L27.1404 43.1601C25.2004 44.2801 22.8003 44.2801 20.8403 43.1601L8.96033 36.3001C7.02033 35.1801 5.82031 33.1 5.82031 30.84V17.1601C5.82031 14.9201 7.02033 12.84 8.96033 11.7L20.8403 4.84C22.7803 3.72 25.1804 3.72 27.1404 4.84L39.0204 11.7C40.9604 12.84 42.1604 14.9001 42.1604 17.1601Z",
    fill: "#FDB022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 27.5C23.18 27.5 22.5 26.82 22.5 26V15.5C22.5 14.68 23.18 14 24 14C24.82 14 25.5 14.68 25.5 15.5V26C25.5 26.82 24.82 27.5 24 27.5Z",
    fill: "#FDB022"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34.4997C23.74 34.4997 23.48 34.4397 23.24 34.3397C22.98 34.2397 22.78 34.0998 22.58 33.9198C22.4 33.7198 22.26 33.4997 22.14 33.2597C22.04 33.0197 22 32.7597 22 32.4997C22 31.9797 22.2 31.4597 22.58 31.0797C22.78 30.8997 22.98 30.7598 23.24 30.6598C23.98 30.3398 24.86 30.5197 25.42 31.0797C25.6 31.2797 25.74 31.4797 25.84 31.7397C25.94 31.9797 26 32.2397 26 32.4997C26 32.7597 25.94 33.0197 25.84 33.2597C25.74 33.4997 25.6 33.7198 25.42 33.9198C25.04 34.2998 24.54 34.4997 24 34.4997Z",
    fill: "#FDB022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning2);
export default __webpack_public_path__ + "static/media/warning-2.f7e31018ea534e9473e94e0d7883045f.svg";
export { ForwardRef as ReactComponent };